interface Props {
  className?: string;
}

export const DashboardDivider = ({ className = 'mt-3' }: Props) => <div className={`border-top ${className}`} />;
